import React from "react";
import {pointService} from "../jwt/_services/xeeker/pointService";

export const pointProvider = {
    getOptions,
    getItem
};

async function getOptions() {
    try {
        const dataRequest = {
            fbDataBase:  null,
            item: {
                code : null
            }
        }
        const listItems = await pointService.search(0,1000, dataRequest)
        return listItems.data.map((itemData) => {
            return (
                {
                    id: itemData.id,
                    value: itemData.code + " - " + itemData.title,
                    label: <div><label>{itemData.code}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message);
    }
}


async function getItem(id) {
    try {
        const item = await pointService.getItem(id);

        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message);
    }
}